module.exports = {
  domain: 'E',
  title: 'Ekstroversjon',
  shortDescription: 'Ekstroversjon kjennetegnes av tydelig engasjement i den ytre verden.',
  description: `De ekstroverte liker å være sammen med mennesker, er fulle av energi, og opplever ofte positive følelser.
 De pleier å være entusiastiske, handlingsorienterte individer som liker å si "Ja!" eller "La oss sette i gang!" når det åpner seg muligheter for å oppleve noe spennende.
 De liker å snakke i grupper, hevde seg selv og rette oppmerksomhet mot seg selv.
 <br /><br />
 De introverte mangler livligheten, energien og aktivitesnivået til de ekstroverte.
 De er ofte stille, nedstemte, forsiktige og lite engasjert i den sosiale verden.
 Deres mangel på sosialt engasjement bør ikke tolkes som reserverthet eller depresjon; den introverte trenger bare mindre stimulering enn den ekstroverte og foretrekker å være alene.
 Uavhengigheten og reservasjonen til den introverte er noen ganger feilaktig sett på som uvennlighet eller arroganse.
 <br /><br />
 I realiteten så vil en introvert som skårer høyt på medmennesklighetsfaktoren ikke søke andre bevisst, men synes det er ganske greit hvis andre søker deres selskap.`,
  results: [
    {
      score: 'low',

      text: `Ditt resultat på ekstroversjon er lavt, noe som tyder på at du er

introvert, reservert og stille. Du liker å være alene og aktiviteter du kan gjøre for deg selv.

Den sosiale delen av livet ditt omfatter noen få nære venner.`
    },
    {
      score: 'neutral',
      text: 'Ditt resultat på ekstroversjon er gjennomsnittlig, noe som tyder på at du verken foretrekker å være alene eller en godmodig pratemaker. Du liker å være med andre, samtidig som du også setter pris på alene-tid.'
    },
    {
      score: 'high',

      text: `Ditt resultat på ekstroversjon er høyt, noe som tyder på at du er sosial, utadvendt, energisk og livlig.

Du foretrekker å være med andre mesteparten av tiden.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Vennlighet',
      text: 'Vennlige mennesker liker andre mennesker og viser åpent positive følelser de har ovenfor andre. De får lettere venner, og det er enkelt for dem å danne nære, intime forhold. De som skårer lavt på vennlighet er ikke nødvendvis kalde og fiendtlige, men de knytter seg ikke til andre og blir oppfattet som distanserte og reserverte.'
    },
    {
      facet: 2,
      title: 'Sosiabilitet',
      text: 'Personer med høy sosiabilitet setter pris på andres selskap og finner det stimulerende og får mye ut av det. De synes det er spennende med mange mennesker. De som skårer lavt føler seg overveldet av mange mennesker, og unngår derfor aktivt slike situasjoner. Det er ikke det at de nødvendigvis misliker å være med mennesker fra tid til annen, men deres behov for privatliv og tid for seg selv er større enn for individer som skårer høyt her.'
    },
    {
      facet: 3,
      title: 'Selvmarkering',
      text: `De som skårer høyt på selvmarkering liker å si i fra, ta ansvar og styre andres aktiviteter. De er ofte leder i grupper.
 
 De som skårer lavt pleier ikke å være så snakkesalige og lar andre kontrollere det som skal foregå i gruppa.`
    },
    {
      facet: 4,
      title: 'Aktivitet',
      text: `Aktive individer er travle og lever hektiske liv. De er som oftest i bevegelse, er raske og energiske, og de er med på mange aktiviteter.

Mennesker som skårer lavt på dette er roligere og følger et mer avslappet løp.`
    },
    {
      facet: 5,
      title: 'Spennings-søking',
      text: `De som skårer høyt på dette kjeder seg lett hvis de ikke opplever så mye stimuli. De elsker mye lys og fart og spenning.

De lever ofte risikofullt og søker spenning. De som skårer lavt blir satt ut av støy og bråk og oppsøker ikke fart og spenning.`
    },
    {
      facet: 6,
      title: 'Positive følelser',
      text: `Denne fasetten måler positive humørsvingninger og følelser, ikke negative følelser (som er en del av nevrotisisme-området).

Personer som skårer høyt her opplever ofte en rekke positive følelser, slik som glede, entusiasme og begeistring.

De som skårer lavt er ikke så tilbøyelige til å føle at de bobler over av energi og glede.`
    }
  ]
}
